import fp from 'lodash/fp';

import { getTimeStamp } from '../../webcommon/common/helpers';

import * as constants from './constants';
import * as actions from './actions';


export const INITIAL_STATE = {
    initialised: false,
    columns: constants.columns,
    rows: [],
    lastUpdated: getTimeStamp(),
    loading: false,
    gridSorting: [],
    currentServerFilters: null
};

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return {
                ...state,
                initialised: true
            };
        }
        case actions.SET_LOADING: {
            return {
                ...state,
                loading: true
            };
        }
        case actions.SET_ROWS: {
            return {
                ...state,
                rows: action.rows,
                lastUpdated: getTimeStamp(),
                loading: false,
                currentServerFilters: action.serverFilters
            };
        }
        case actions.GET_IMPACT_ID_LIST_FAILED: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.GET_IMPACT_ID_LIST_EMPTY: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.SET_GRID_SORTS: {
            return fp.set('gridSorting', action.sorting)(state);
        }
        case actions.SET_ALL_GRID_SORTS: {
            return fp.set('gridSorting', action.data)(state);
        }
        default:
            return state;
    }
}
